<template>
  <section
    v-editable="blok"
    :class="`${getClassNames(blok.alignment)}${animationClass}`"
  >
    <div :class="getContainerClass(blok.alignment)">
      <div :class="setRows">
        <div
          v-if="blok.image.length < 2 && blok.alignment !== 'center'"
          :class="setColumns"
          class="article-with-image__content article-with-image__content--text"
        >
          <h2 v-if="blok.title" class="article-with-image__title">
            {{ blok.title }}
          </h2>

          <!-- eslint-disable vue/no-v-html -->
          <div
            v-if="getCopy(blok.copy)"
            class="article-with-image__copy"
            v-html="getCopy(blok.copy)"
          />
          <!--eslint-enable-->
        </div>

        <template v-for="image in blok.image">
          <div
            v-if="image.image"
            :key="image._uid"
            v-editable="image"
            :class="setColumns"
            class="article-with-image__content article-with-image__content--image col-12 sticky"
          >
            <component
              :is="'a_imageSource' | dashify"
              :blok="image"
              :image-url="image.image"
              :alt="blok.title || 'article picture'"
            />
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ArticleWithImage',
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: () => false,
    },
    animateWhenVisible: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      animationClass: '',
    }
  },
  computed: {
    setRows() {
      if (this.blok.alignment !== 'center') {
        return 'row'
      }
      return ''
    },
    setColumns() {
      if (this.blok.alignment !== 'center') {
        return 'col-12 col-md-6 col-lg-6'
      }
      return ''
    },
  },
  watch: {
    visible(visible) {
      if (visible) {
        this.animationClass =
          ' article-with-image--animate article-with-image--animate-in'
      } else {
        this.animationClass =
          ' article-with-image--animate article-with-image--animate-done'
      }
    },
  },
  mounted() {
    if (this.animateWhenVisible) {
      this.animationClass = ' article-with-image--animate'
    }
  },
  methods: {
    getCopy: (gerenicText) => {
      if (gerenicText && gerenicText[0] && gerenicText[0].text) {
        return gerenicText[0].text.content
      }
      return null
    },
    getClassNames: (align) => {
      switch (align) {
        case 'center':
          return 'theme-light article-with-image article-with-image--center'
        case 'right':
          return 'theme-light article-with-image article-with-image--right'
        case 'left':
          return 'theme-light article-with-image article-with-image--left'
        case 'both':
          return 'theme-light article-with-image article-with-image--both'
        default:
          return 'theme-light article-with-image'
      }
    },
    getContainerClass(align) {
      if (align !== 'center') {
        return 'container'
      }
      return ''
    },
  },
}
</script>

<style lang="scss">
@import '../../../assets/scss/settings';

.article-with-image {
  &--animate {
    .article-with-image__title,
    .article-with-image__copy {
      opacity: 0;
      transform: translate(0, 30px);
      transition: all 0.3s ease-out 0.2s;
    }
    .article-with-image__content--image {
      opacity: 0;
      transform: scale(0.7);
      transition: all 0.3s ease-out 0.3s;
    }
    &-done {
      .article-with-image__title,
      .article-with-image__copy {
        opacity: 1;
        transform: translate(0, 0);
      }
      .article-with-image__content--image {
        opacity: 1;
        transform: scale(1);
      }
    }
    &-in {
      .article-with-image__title,
      .article-with-image__copy {
        opacity: 1;
        transform: translate(0, 0);
      }
      .article-with-image__content--image {
        opacity: 1;
        transform: scale(1);
      }
    }
  }

  &--center {
    max-width: 100%;
    .article-with-image__content {
      margin: 0;
      padding: 0;

      &--image img {
        box-shadow: none;
      }
    }
  }

  &__title {
    @include font-size(36);
    @include font-family($font-family-headings-bold, $headings-font-weight);

    margin: 0 0 spacer(1) 0;
    align-self: flex-start;
  }

  &__copy {
    @include font-size(16, rem-v(28));

    margin: 0 0 $spacer;

    p {
      @include font-size(16, rem-v(28));
    }

    a {
      @include font-family($font-family-headings-bold, $headings-font-weight);
    }
  }

  &__content {
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    &--image {
      margin: 0 0 spacer(2) 0;

      img {
        background: $white;
        box-shadow: 0 25px 50px -20px rgba(0, 0, 0, 0.4);
        max-width: 100%;
        width: 100%;
      }
    }
  }
}

@include media-breakpoint-up(md) {
  .article-with-image__title {
    @include font-size(36, rem-v(48));

    margin-bottom: spacer(1.5);
  }

  .article-with-image--right {
    .article-with-image__content--text {
      padding: 0 spacer(1.5) 0 spacer(1);
    }

    .article-with-image__content--image {
      padding: 0 spacer(1.5) 0 spacer(3.5);
    }
  }

  .article-with-image--left {
    .article-with-image__content--text {
      padding: 0 spacer(1) 0 spacer(1.5);
      order: 2;
    }

    .article-with-image__content--image {
      padding: 0 spacer(3.5) 0 spacer(1.5);
    }
  }

  .article-with-image--both {
    .article-with-image__content--image {
      padding: 0 spacer(2) 0 spacer(2);
    }
  }
}
</style>
